import {Pipe, PipeTransform} from '@angular/core';
import {isArray}             from 'util';

@Pipe({
  name: 'join',
})
export class JoinPipe implements PipeTransform {

  private static initOptions(separator, fieldSeparator, fields): { separator: string, fieldSeparator: string, fields: string[] } {
    separator = separator ? separator : ', ';
    fieldSeparator = fieldSeparator ? fieldSeparator : separator;
    fields = fields.length !== 0 ? fields : ['name'];

    return {
      separator,
      fieldSeparator,
      fields,
    };
  }

  transform(value: any[], separator?: string, fieldSeparator?: string, ...fields: string[]): string {
    if (isArray(value)) {
      const options = JoinPipe.initOptions(separator, fieldSeparator, fields);

      return value
        .map((item) => {
          const foo = options.fields
            .map((field) => item[field] ? item[field] : null)
            .filter((field) => field !== null)
            .join(options.fieldSeparator);
          return foo;
        })
        .join(options.separator);
    }

    return null;
  }
}
